import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ContextComponent from "../../../../../AppContext";
import Utils from "../../../../../Utils";
import { FloatingLabel, Form, Modal } from "react-bootstrap";

const AddLinkPage = ({ props }) => {
    const { siteid } = useParams();

    const [currSiteId, setCurrSiteId] = useState(siteid);

    let { setAlert, setLoadingState, setCanRedirectToLogin } = useContext(ContextComponent);

    const [linkCode, setLinkCode] = useState("");
    const [title, setTitle] = useState("");
    const [linkText, setLinkText] = useState("");
    const [linkSrc, setLinkSrc] = useState("");
    let LINKTYPE = Utils.LINK_TYPE || {};
    const [type, setType] = useState(LINKTYPE[0].value);
    const [description, setDescription] = useState("");
    const [image, setImage] = useState("");
    const isUpdatedView = props?.isUpdatedView ?? Utils?.getUpdatedViewMapValue(siteid);

    const hideModal = (e) => {
        props.setAddModalCanOpen(false);
    };

    const linkCodeHandler = (e) => {
        setLinkCode(e.currentTarget.value);
    }

    const linkTitleHandler = (e) => {
        setTitle(e.currentTarget.value);
    };

    const linkTextHandler = (e) => {
        setLinkText(e.currentTarget.value);
    }

    const linkSrcHandler = (e) => {
        setLinkSrc(e.currentTarget.value);
    };

    const linkTypeHandler = (e) => {
        setType(e.currentTarget.value);
    };

    const linkDescriptionHandler = (e) => {
        setDescription(e.currentTarget.value);
    };

    const onChangeImage = async (e) => {
        let file = e.currentTarget.files[0];
        let targetImage = e.currentTarget.attributes["imgname"].value;
        // let targetIndex = parseInt(
        //     e.currentTarget.attributes["imgindex"].value,
        //     10,
        // );
        document
            .querySelector(".indi-add-img-wrapper-" + targetImage)
            .classList.add("d-none");
        let imgPreviewEle = document.querySelector(
            ".indi-add-img-wrapper-preview-" + targetImage,
        );
        imgPreviewEle.classList.remove("d-none");
        await Utils.fileToDataUri(file).then((dataUri) => {
            imgPreviewEle.src = dataUri;
            setImage(dataUri);
            imgPreviewEle.src = dataUri;
        });
    };

    const saveLink = (e) => {
        // --- VALIDATION ---
        if (Utils?.isEmpty(linkCode)) {
            setAlert({
                show: true,
                message: "Link Code is required & Unique.",
                type: "danger",
            });
            return;
        }
        if (Utils.isEmpty(title)) {
            setAlert({
                show: true,
                message: "Title is required.",
                type: "danger",
            });
            return;
        }
        if (Utils.isEmpty(linkSrc)) {
            setAlert({
                show: true,
                message: "URL is required.",
                type: "danger",
            });
            return;
        }
        if (!Utils.isValidUrl(linkSrc)) {
            setAlert({
                show: true,
                message: "Please enter a valid URL.",
                type: "danger",
            });
            return;
        }
        if (!isUpdatedView && Utils?.isEmpty(image)) {
            setAlert({
                show: true,
                message: "Image is required.",
                type: "danger",
            });
            return;
        }
        // --- Valid Payload so Make API Call ---
        setLoadingState({
            applyMask: true,
            text: "Saving Link",
        });

        const success = (res) => {
            hideModal();
            setLoadingState({
                applyMask: false
            });
            setAlert({
                show: true,
                message: res?.data?.message
                    ? res.data.message
                    : "Link added successfully!",
                type: "success",
            });

            props?.loadFreshLinks(currSiteId);
        };
        const fail = (err) => {
            setLoadingState({
                applyMask: false
            });
            if (err?.redirect) {
                setCanRedirectToLogin(true);
            }
            setAlert({
                show: true,
                message: err?.data?.message
                    ? err.data.message
                    : "Link addition failed",
                type: "danger",
            });
            console.log(err);
        };
        let linkInfo = {
            linkCode,
            title,
            description,
            linkText,
            linkSrc,
            type,
            ...(isUpdatedView ? {} : { image }),
        };

        // console.log("final Field data");
        // console.log(fieldInfo);
        // console.log("saving the Field")
        try {
            // debugger;
            // console.log(formData);
            Utils.addLink(currSiteId, linkInfo).then(success, fail);
        } catch (e) {
            console.log(e);
        }

    }

    useEffect(() => { }, [props?.addModalCanOpen]);

    const handleClose = (e) => {
        props.setAddModalCanOpen(false);
    };

    return (
      <Modal
        centered
        show={props.addModalCanOpen}
        className={!isUpdatedView ? "indi-medium-modal" : ""}
        onHide={handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title>Add new Link</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="indi-add-form-wrapper d-flex flex-column">
              <div className="indi-add-form-item d-flex flex-column">
                <div className="indi-add-form-item-input row">
                  <FloatingLabel
                    label={
                      <span>
                        Link Code <span className="text-danger">*</span>
                      </span>
                    }
                  >
                    <Form.Control
                      type="text"
                      className="indi-input-field"
                      id="linkcode"
                      placeholder="Enter Link Code"
                      autoComplete="off"
                      onChange={linkCodeHandler}
                    />
                  </FloatingLabel>
                </div>
              </div>
              <div className="indi-add-form-item d-flex flex-column">
                <div className="indi-add-form-item-input row">
                  <FloatingLabel
                    label={
                      <span>
                        Title <span className="text-danger">*</span>
                      </span>
                    }
                  >
                    <Form.Control
                      type="text"
                      className="indi-input-field"
                      id="title"
                      placeholder="Enter Link Title"
                      autoComplete="off"
                      onChange={linkTitleHandler}
                    />
                  </FloatingLabel>
                </div>
              </div>
              <div className="indi-add-form-item d-flex flex-column">
                <div className="indi-add-form-item-input row">
                  <FloatingLabel label="Description">
                    <Form.Control
                      as="textarea"
                      className="indi-input-field"
                      id="description"
                      placeholder="Enter Link Description"
                      autoComplete="off"
                      onChange={linkDescriptionHandler}
                    />
                  </FloatingLabel>
                </div>
              </div>
              <div className="indi-add-form-item d-flex flex-column">
                <div className="indi-add-form-item-input row">
                  <FloatingLabel
                    label={
                      <span>
                        URL <span className="text-danger">*</span>
                      </span>
                    }
                  >
                    <Form.Control
                      type="text"
                      className="indi-input-field"
                      id="linksrc"
                      placeholder="Enter Link Src"
                      autoComplete="off"
                      onChange={linkSrcHandler}
                    />
                  </FloatingLabel>
                </div>
              </div>
              {!isUpdatedView && (
                <div className="indi-add-form-item d-flex flex-column">
                  <div className="indi-add-form-item-input row">
                    <FloatingLabel label="Alt Text">
                      <Form.Control
                        type="text"
                        className="indi-input-field"
                        id="linktext"
                        placeholder="Enter Link Text"
                        autoComplete="off"
                        onChange={linkTextHandler}
                      />
                    </FloatingLabel>
                  </div>
                </div>
              )}
              <div className="indi-add-form-item d-flex flex-column">
                <div className="indi-add-form-item-input row">
                  <FloatingLabel label="Link Type">
                    <Form.Select
                      defaultValue={type}
                      id="type"
                      onChange={linkTypeHandler}
                      size="sm"
                      className="indi-input-field indi-input-select-field"
                    >
                      {LINKTYPE.map((link, index) => (
                        <option value={link.value} key={index}>
                          {link.name}
                        </option>
                      ))}
                    </Form.Select>
                  </FloatingLabel>
                </div>
              </div>
              {!isUpdatedView && (
                <div className="indi-add-form-item d-flex flex-row">
                  <div className="indi-add-form-item-input col">
                    <label htmlFor="iconImage" className="form-label">
                      {
                        <span>
                          Link Image: <span className="text-danger">*</span>
                        </span>
                      }
                    </label>
                    <div className="indi-add-form-item-input indi-upload-picture-file-input-wrapper">
                      <input
                        type="file"
                        imgname="linkImage"
                        id="linkImage"
                        imgindex={0}
                        className="indi-upload-picture-file-input"
                        onChange={onChangeImage}
                      />
                      <div className="indi-add-img-wrapper"></div>
                    </div>
                  </div>
                  <div className="indi-add-form-item-input col">
                    <div className="indi-add-img-wrapper-linkImage d-none">
                      no preview
                    </div>
                    <img
                      src={image}
                      alt="background"
                      className="indi-add-img-wrapper-preview indi-add-img-wrapper-preview-linkImage"
                    />
                  </div>
                </div>
              )}
            </div>
            <div className="indi-add-footer">
              <div className="indi-add-page-footer-btn-wrapper float-right">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={hideModal}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={saveLink}
                >
                  Save
                </button>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    );
};

export default AddLinkPage;